import React, { useRef } from 'react';
import MLTextField from '../../../components/MLTextField/MLTextField';
import styles from './SearchBar.module.css';

const SearchBar = ({ searchValue, setSearchValue, testId }) => {
  const inputRef = useRef();

  const handleClear = () => {
    setSearchValue('');
    inputRef.current?.focus();
  };

  const handleFocus = () => {
    inputRef.current?.focus();
  };

  return (
    <MLTextField
      inputRef={inputRef}
      type="text"
      placeholder="Search Students"
      value={searchValue}
      onChange={(_e, value) => setSearchValue(value)}
      containerClassName={styles.searchBarContainer}
      className={styles.searchBarInput}
      iconType={searchValue ? 'x' : 'search'}
      iconClassName={searchValue ? styles.clearIcon : styles.searchIcon}
      iconOnClick={searchValue ? handleClear : handleFocus}
      testId={testId}
    />
  );
};

export default SearchBar;
